import { render, staticRenderFns } from "./tagsSearchSecond.vue?vue&type=template&id=731f1e32&scoped=true"
import script from "./tagsSearchSecond.vue?vue&type=script&lang=js"
export * from "./tagsSearchSecond.vue?vue&type=script&lang=js"
import style0 from "./tagsSearchSecond.vue?vue&type=style&index=0&id=731f1e32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731f1e32",
  null
  
)

export default component.exports